import React, { useState, useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import "./machineCapabilities.css"
import logoEquipments from "../../imagens/logos/logoEquipments.png"


function MachineCapabilities({ listaMachine }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)

    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }


    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(listaMachine.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, listaMachine.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listaMachine.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)

    }, [slideNumber, listaMachine.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div>
            {
                openModal &&
                <div className='machineSliderWrap'>
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="machineBtnPrev" onClick={() => prevSlide()} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="machineBtnNext" onClick={() => nextSlide()} />
                    <FontAwesomeIcon icon={faCircleXmark} className="machineBtnClose" onClick={() => handleCloseModal()} />
                    <img className='machineFullScreenImage' src={listaMachine[slideNumber].img} alt='machineImg' />
                </div>
            }
            <div>
                <img className='img-custom-size img-fluid ms-2' src={logoEquipments} alt='logoMachines' />
            </div>
            <div className="machineGalleryWrap mx-2">
                {
                    listaMachine && listaMachine.map((image, index) => {
                        return (
                            <div
                                className="machineSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="machines" />

                            </div>
                        )
                    })
                }
            </div>
            <div className="text-center text-nowrap my-3">
                <Link to="/Capabilities/Production">
                    <button className="buttonCapabilities">Back to Production Capabilities</button>
                </Link>
            </div>



        </div>
    )
}

export default MachineCapabilities